<!--MENÚ CONTEXTUAL OCULTO -->
<div id="menuIzq" style="position: fixed;" [style.left]="menuTopLeftPosition.x" [style.top]="menuTopLeftPosition.y"
    [matMenuTriggerFor]="rightMenu">
    <!-- standard material menu -->
    <mat-menu #rightMenu="matMenu">
        <ng-template matMenuContent let-item="item">

            <button mat-menu-item (click)="deleteArchivo()">
                <mat-icon class="iconoMenVer" [ngStyle]="{'color':'grey'}">delete</mat-icon>
                {{ 'gestion.seguimiento.actas.eliminar' | translate }}
            </button>
        </ng-template>
    </mat-menu>
</div>

<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="aniosDisponibles"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioAnio($event)"
  />
  <app-filters filtros
    [name]="'filtros.lider' | translate"
    [array]="responsablesActas" [typeFilter]="Filters.SUCURSALES"
    [click]="false" [consolidado]="selecAllResActas"
    (eventClick)="cambioLider($event)"
  />
  <app-filters filtros
    [name]="'filtros.res' | translate"
    [array]="responsablesActividadesActas" [typeFilter]="Filters.SUCURSALES"
    [click]="false" [consolidado]="selecAllResActiv"
    (eventClick)="cambioResponsable($event)"
  />

  <div borrador [ngStyle]="{'color':'gray'}"
    (click)="borrarFiltro()" class="iconoMen" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
      <img src="./../../../../assets/img/eraser.png">
  </div>

  <div contenido class="zonaClass">
    <div class="zonaTarjetas">
      @for (act of actasMostrar; track $index) {
        <div class="filosofiaCMI tarjetaInformativa">
          <div class="headerTarjetaInformativa w3-titulo-contenidomenuSC">
            <div class="w3-noventa2 hijoizquierdaTitle">
              <span class="w3-margin-left-contenido textoZon">{{'gestion.seguimiento.planes.avance' | translate}} {{act.nombre}}</span>
            </div>
          </div>
          <div class="bodyTarjetaInformativa">
            <span [ngClass]="texto(cumplimiento(act, 'plan'))" class="cifraPrin">{{cumplimiento(act, 'plan')}} %</span>
          </div>
        </div>
      }
    </div>
    <div class="zonaTablas">
      <app-contenedor-elementos [header]="{
        title: ''
      }">
        <div iconos>
          <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menu2">more_vert</mat-icon>
        </div>
        <mat-menu #menu2="matMenu">
          <button (click)="exportarExcel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar' | translate}}</span>
          </button>
          <button (click)="exportarExcelEst()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'gestion.seguimiento.planes.exportarEst' | translate}}</span>
          </button>
        </mat-menu>

        <div body class="tabla">
          @if (!mostabla) {
            <app-skeleton-table/>
          }@else {
            <table class="tabla-aleema">
              <thead>
                <tr>
                  <th>
                    @if (mostrarAllActas) {
                      <mat-icon class="iconoMen" matTooltip="{{'gestion.seguimiento.proy-estra.tooltipOcultarAll' | translate}}" matTooltipPosition="left" (click)="mostrarTodasLasActas()">expand_less</mat-icon>
                    }@else {
                      <mat-icon class="iconoMen" matTooltip="{{'gestion.seguimiento.proy-estra.tooltipMostrarAll' | translate}}" matTooltipPosition="left" (click)="mostrarTodasLasActas()">expand_more</mat-icon>
                    }
                  </th>
                  <th (click)="ordenamientoTabla()" class="contenedorSort" style="width: 20vw; cursor: pointer;">
                    {{'gestion.seguimiento.planes.titTab1' | translate}}
                    @switch (ordenamiento) {
                      @case ('id') {<mat-icon class="iconoSortIni">sort_by_alpha</mat-icon>} 
                      @case ('asc') {<mat-icon class="iconoSortIni">vertical_align_bottom</mat-icon>} 
                      @case ('des') {<mat-icon class="iconoSortIni">vertical_align_top</mat-icon>}
                    }
                  </th>
                  <th class="anchosColumnas"> {{'gestion.seguimiento.planes.titTab2' | translate}} </th>
                  <th class="anchosColumnas"> {{'gestion.seguimiento.planes.titTab3' | translate}} </th>
                  <th class="anchosColumnas"> {{'gestion.seguimiento.planes.titTab4' | translate}} </th>
                  <th class="anchosColumnas"> {{'gestion.seguimiento.planes.titTab5' | translate}} </th>
                  <th class="anchosColumnas"> {{'gestion.seguimiento.planes.titTab6' | translate}} </th>
                  <th class="anchosColumnas"> {{'gestion.seguimiento.planes.titTab7' | translate}} </th>
                  <th class="anchosColumnas"> {{'gestion.seguimiento.planes.titTab8' | translate}} </th>
                  @if (actasMostrar.length !== 0) {
                      @for (ad of adicionales; track $index) {
                        <th class="anchosColumnas">{{ad.name}}</th>
                      }
                  }
                </tr>
              </thead>
              @for (actas of actasMostrar; track $index) {
                <tbody>
                  <tr>
                    <td>
                      @if (actas.check) {
                        <mat-icon class="iconoMen w3-button" matTooltip="{{'gestion.formulacion.proy-estra.tooltipOcultar' | translate}}" matTooltipPosition="left" (click)="mostrarActas(actas)">expand_less</mat-icon>
                      }@else {
                        <mat-icon class="iconoMen w3-button" matTooltip="{{'gestion.formulacion.proy-estra.tooltipMostrar' | translate}}" matTooltipPosition="left" (click)="mostrarActas (actas)">expand_more</mat-icon>
                      }
                    </td>
                    <td class="textoOverFlow" style="width: 20vw!important;"
                    [matTooltip]="actas.nombre" [appOverflowTooltip]="actas.nombre">
                      {{actas.nombre}}
                    </td>
                    <td style="min-width: 7vw; max-width: 20vw;">
                      <span>{{obtFecha(actas.fecha_ini)}}</span>
                    </td>
                    <td style="min-width: 7vw; max-width: 23vw; line-height: 1.2;">
                      <span>{{obtFecha(actas.fecha_fin)}}</span>
                    </td>
                    <td class="textoOverFlow" style="min-width: 5vw; max-width: 20vw;"
                    [matTooltip]="actas.responsable.position" [appOverflowTooltip]="actas.responsable.position">
                      {{actas.responsable.position}}
                    </td>
                    <td><br></td>
                    <td>{{escribirDatPro(actas,'plan')}}</td>
                    <td [ngClass]="pintarBordPro(escribirDatPro(actas, 'ejec'),escribirDatPro(actas, 'plan'))"
                    style="background-color: #e7e7e7;">
                      {{escribirDatPro(actas,'ejec')}}</td>
                    <td>{{cumplimiento(actas, 'plan')}} %</td>
                    @if (actas.actividades.length !== 0) {
                      @for (ad of actas.actividades[0].adicionales; track ad; let i = $index) {
                        <td>{{escribirAdicionalPro(actas.actividades, i)}}</td>                        
                      }
                    }@else{
                      <td class="alinDer" style="min-width: 5vw; max-width: 20vw;"><br></td>
                    }
                  </tr>
                  @if (actas.check) {
                    @for (act of actas.actividades; track act;) {                      
                      @if(existAct(act)){
                        <tr>
                          <td></td>
                          <td class="textoOverFlow" style="min-width: 5vw; max-width: 20vw;"
                          [matTooltip]="act.nombre" [appOverflowTooltip]="act.nombre">
                            {{act.nombre}}
                          </td>
                          <td class="w3-center" style="min-width: 5vw; max-width: 20vw;">
                            {{obtFecha(act.fecha_inicio)}}</td>
                          <td class="w3-center" style="min-width: 5vw; max-width: 20vw;">
                            {{obtFecha(act.fecha_fin)}}</td>
                          <td class="textoOverFlow w3-center" style="min-width: 5vw; max-width: 20vw;"
                          [matTooltip]="act.responsable.position" [appOverflowTooltip]="act.responsable.position">
                            {{act.responsable.position}}
                          </td>
                          <td>{{avanceAcumulado(act)}}</td>
                          <td>{{escribirDat(act.history, 'plan')}}</td>
                          <ng-container *appRoles="permisos.SEGUIMIENTO">
                            @if (escribirDat(act.history, 'ejec') === null) {
                              <td [ngClass]="pintarBord(escribirDat(act.history, 'ejec'),escribirDat(act.history, 'plan'))" class="textoOverFlow alinRight borderAllLow marginsH" 
                              style="background-color: #e7e7e7; cursor: pointer;" (dblclick)="editar(act.history, act.id)" matTooltip="{{'gestion.seguimiento.proy-estra.tooltipCap' | translate}}">-</td>
                            }@else {
                              <td [ngClass]="pintarBord(escribirDat(act.history, 'ejec'),escribirDat(act.history, 'plan'))" class="textoOverFlow alinRight borderAllLow marginsH" 
                                (dblclick)="editar(act.history, act.id)" style="background-color: #e7e7e7; cursor: pointer;" matTooltip="{{'gestion.seguimiento.proy-estra.tooltipCap' | translate}}">
                                {{escribirDat(act.history, 'ejec')}}
                              </td>
                            }                           
                          </ng-container>
                          <ng-container *appRolesNeg="permisos.SEGUIMIENTO">
                            @if (escribirDat(act.history, 'ejec') === null) {
                              <td [ngClass]="pintarBord(escribirDat(act.history, 'ejec'),escribirDat(act.history, 'plan'))"
                                style="background-color: #e7e7e7;">-</td>
                            }@else {
                              <td [ngClass]="pintarBord(escribirDat(act.history, 'ejec'),escribirDat(act.history, 'plan'))"
                                style="background-color: #e7e7e7;">
                                {{escribirDat(act.history, 'ejec')}}
                              </td>
                            }
                          </ng-container>
                          <td>{{cumplimiento(act, '')}}</td>
                          @for (ad of act.adicionales; track $index) {
                            <ng-container *appRoles="permisos.SEGUIMIENTO">
                              @if (ad.type !== 'numero' && ad.type !== 'moneda' && ad.type !== 'archivo') {
                                <td class="textoOverFlow w3-center anchoAdi" style="cursor: pointer;" (dblclick)="edicionAd(ad, act.id, $event)" 
                                  [matTooltip]="escribirAdicional(ad)" [appOverflowTooltip]="escribirAdicional(ad)">
                                  {{escribirAdicional(ad)}}
                                </td>
                              }                              
                            </ng-container>
                            <ng-container *appRolesNeg="permisos.SEGUIMIENTO">
                              @if (ad.type !== 'numero' && ad.type !== 'moneda' && ad.type !== 'archivo') {
                                <td class="textoOverFlow alinRight anchoAdi"
                                [matTooltip]="escribirAdicional(ad)" [appOverflowTooltip]="escribirAdicional(ad)">
                                  {{escribirAdicional(ad)}}
                                </td>
                              }                              
                            </ng-container>
                            @switch (ad.type) {
                              @case ('moneda') {
                                <td class="textoOverFlow alinRight anchoAdi"
                                [matTooltip]="escribirAdicional(ad)" [appOverflowTooltip]="escribirAdicional(ad)">
                                  {{escribirAdicional(ad)}}
                                </td>
                              }
                              @case ('numero') {
                                <td class="textoOverFlow alinRight anchoAdi"
                                [matTooltip]="escribirAdicional(ad)" [appOverflowTooltip]="escribirAdicional(ad)">
                                  {{escribirAdicional(ad)}}
                                </td>
                              }
                              @case ('archivo') {
                                <td class="textoOverFlow w3-center anchoAdi">
                                  <div *appRoles="permisos.SEGUIMIENTO">
                                    @if (escribirAdicional(ad) !== '') {
                                      <div class="iconoArch" style="cursor: pointer;" (contextmenu)="onContextMenu($event, ad, act)" (click)="abirPDF(ad, $event);">
                                        <mat-icon matTooltip="{{escribirAdicional(ad)}}" class="iconoMen" [ngStyle]="{'color':'#4E9AC7'}">attach_file</mat-icon>
                                      </div>
                                    }@else {
                                      <div class="iconoArch" style="cursor: pointer;" (dblclick)="edicionAd(ad, act.id, $event)">
                                        <mat-icon  matTooltip="{{'gestion.seguimiento.proy-estra.tooltipAdj' | translate}}" class="iconoMen" [ngStyle]="{'color':'#C8C7C8'}">attach_file</mat-icon>
                                      </div>
                                    }                                    
                                  </div>
                                  <div *appRolesNeg="permisos.SEGUIMIENTO">
                                    @if (escribirAdicional(ad) !== '') {
                                      <div class="iconoArch" style="cursor: pointer;" (click)="abirPDF(ad, $event);">
                                        <mat-icon matTooltip="{{escribirAdicional(ad)}}" class="iconoMen" [ngStyle]="{'color':'#4E9AC7'}">attach_file</mat-icon>
                                      </div>
                                    }@else {
                                      <div class="iconoArch">
                                        <mat-icon class="iconoMen" [ngStyle]="{'color':'#C8C7C8'}">attach_file</mat-icon>
                                      </div>
                                    }
                                  </div>
                                </td>
                              }
                            }
                          }
                        </tr>
                      }                      
                    }
                  }
                </tbody>
              }
            </table>
          }
        </div>

      </app-contenedor-elementos>
    </div>
  </div>
</app-esqueleto-tableros>